/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getVehicleList: (params) => {
    return axios.get(API_ENDPOINTS.GET_VEHICLE_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getVehicleById: (id) => {
    return axios.get(API_ENDPOINTS.GET_VEHICLE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  addVehicle: (data) => {
    return axios.post(API_ENDPOINTS.ADD_VEHICLE, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data","x-tenant-slug":"default" },
    });
  },
  updateVehicle: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_VEHICLE + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data","x-tenant-slug":"default" },
    });
  },
  deleteVehicle: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_VEHICLE + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  assignDriver: (data) => {
    return axios.post(API_ENDPOINTS.ASSIGN_DRIVER, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  createDriverVehicleAssignment: (data) => {
    return axios.post(API_ENDPOINTS.GET_DRIVER_VEHICLE_ASSIGNMENTS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
};
